import { render } from "./PlayerServiceBoxTwo.vue?vue&type=template&id=60987a3b&scoped=true"
import script from "./PlayerServiceBoxTwo.vue?vue&type=script&lang=js"
export * from "./PlayerServiceBoxTwo.vue?vue&type=script&lang=js"

import "./PlayerServiceBoxTwo.vue?vue&type=style&index=0&id=60987a3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60987a3b"]])

export default __exports__